module.exports = __webpack_public_path__ + "static/nlp-ba37fcec94fa2a6e5cb1448912786f4c.svg";